// src/components/LandingPage/LandingPage.js
import React, { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import Logo from '../Layout/Logo';
import styles from './LandingPage.module.css';

// Import the background image
import landingBackgroundImage from '../../assets/img/backgrounds/landingbackground.jpeg';

const LandingPage = () => {
  const { signInWithGoogle, continueAsGuest, authLoading, signInError, clearSignInError } = useContext(AuthContext);
  const [isSigningIn, setIsSigningIn] = React.useState(false);

  const handleGoogleSignIn = async () => {
    setIsSigningIn(true);
    clearSignInError();
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error("[LandingPage] Sign-in error:", error);
      setIsSigningIn(false);
    }
  };

  return (
    <div className={styles.landingContainer}>
      <div
        className={styles.backgroundImage}
        style={{ backgroundImage: `url(${landingBackgroundImage})` }} // Apply image via inline style
      ></div>
      <div className={styles.contentBox}>
        <Logo />
        <h1 className={styles.gameTitle}>Ember & Anvil</h1>
        <p className={styles.tagline}>Craft your destiny in a world of adventure!</p>

        <button
          onClick={handleGoogleSignIn}
          disabled={isSigningIn || authLoading}
          className={`${styles.button} ${styles.googleButton}`}
        >
          <img src="/img/google.png" alt="Google icon" className={styles.buttonIcon} />
          {isSigningIn ? 'Signing in...' : 'Sign in with Google'}
        </button>

        {signInError && (
          <div className={styles.errorMessage}>
            <div className={styles.errorContent}>
              ⚠️ {signInError}
            </div>
            <small className={styles.troubleshootingTips}>
              Troubleshooting tips:
              <br />• Disable popup blockers for this site
              <br />• Enable third-party cookies
              <br />• Try incognito/private browsing mode
              <br />• Check your internet connection
              <br />• Refresh the page and try again
            </small>
            <button 
              onClick={clearSignInError}
              className={styles.clearErrorButton}
            >
              ✕ Dismiss
            </button>
          </div>
        )}

        <button
          onClick={continueAsGuest}
          className={`${styles.button} ${styles.guestButton}`}
        >
          Continue as Guest
        </button>

        <div className={styles.footerLinks}>
          <a href="https://discord.gg/XjHEFm3F" target="_blank" rel="noopener noreferrer">Join us on Discord</a>
          {/* Add other links like patch notes, community, etc. */}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;